// @ts-nocheck

import React, { useCallback, useEffect, useRef, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { NotConnected1 } from '../../../assets/img/index';
import { Target } from '../../../client';
import Modal from '../../../components/Modal';
import NotFoundView from '../../../components/NotFoundView/NotFoundView';
import WinaLoader from '../../../components/WinaLoader';
import { ModalContentSpacing } from '../../../constants/ui/modal';
import useRouter from '../../../hooks/useRouter';
import { __ } from '../../../i18n/l10n';
import {
  selectUserConnected,
  selectUserConnecting,
  selectUserDidReceivedUserData,
} from '../../../selectors/user/userPrimary.selector';
import { RoutePatterns } from '../../../types/routes';
import { showWebsiteLoginForm } from '../../../utils';
import RoutesRedirectionFactory from '../../../utils/routes/RoutesRedirectionFactory';
import GREnrollmentContainer from '../containers/GREnrollmentContainer';
import GRHomeContainer from '../containers/GRHomeContainer';
import GRRoundRulesContainer from '../containers/GRRoundRulesContainer';
import { selectGRGlobalState } from '../selectors/global';
import { selectIsGREnabledAndNotForbidden } from '../selectors/specifics/selectGRRuntime';
import { selectGRUserStatus } from '../selectors/user';
import { GROperationUserStatuses } from '../types/user';

const StyledWinaLoader = styled(WinaLoader)`
  margin: 0;
  margin-top: 44.1vh;
  transform: translateY(-50%);
`;

const GRMainRouterSwitch = () => {
  const history = useHistory();

  const didReceivedUserData = useSelector(selectUserDidReceivedUserData);
  const GRUserStatus = useSelector(selectGRUserStatus);
  const GRUserStatusRef = useRef(GRUserStatus);

  useLayoutEffect(() => {
    // Si l'utilisateur doit être redirigé ou non vers la vue d'enregistrement à l'opération

    if (didReceivedUserData) {
      if (!GRUserStatusRef.current || GRUserStatusRef.current === GROperationUserStatuses.OFF) {
        history.push(RoutesRedirectionFactory.getGREnrollementRouteConfig());
      }
    }
  }, [didReceivedUserData, history]);

  return (
    <Switch>
      <Route path={RoutePatterns.GR} exact>
        <GRHomeContainer />
      </Route>
      <Route path={RoutePatterns.GR_ROUND_RULES} exact>
        <GRRoundRulesContainer />
      </Route>
    </Switch>
  );
};

const GRSubRouterSwitch = () => {
  const history = useHistory();

  const isConnected = useSelector(selectUserConnected);
  const isConnecting = useSelector(selectUserConnecting);
  const didReceivedUserData = useSelector(selectUserDidReceivedUserData);
  const isGREnabled = useSelector(selectIsGREnabledAndNotForbidden);
  const GRGlobalState = useSelector(selectGRGlobalState);

  const isConnectedRef = useRef(isConnected);
  const isConnectingRef = useRef(isConnecting);
  const GRGlobalStateRef = useRef(GRGlobalState);

  useEffect(() => {
    isConnectedRef.current = isConnected;
  }, [isConnected]);

  useEffect(() => {
    isConnectingRef.current = isConnecting;
  }, [isConnecting]);

  useEffect(() => {
    GRGlobalStateRef.current = GRGlobalState;
  }, [GRGlobalState]);

  useLayoutEffect(() => {
    // Si un utilisateur tente de craft l'URL on doit le rediriger vers la home
    if (!GRGlobalStateRef.current || (Object.keys(GRGlobalStateRef.current).length === 0 && !isGREnabled)) {
      history.push(RoutesRedirectionFactory.getHomeRouteConfig());
    }

    // Si un utilisateur n'est pas connecté et qu'il n'est pas en train de se connecter
    // on doit le rediriger vers la page de login
    if (!isConnectedRef.current && !isConnectingRef.current) {
      if (Target.__MOBILE__) {
        history.push({
          ...RoutesRedirectionFactory.getLoginRouteConfig({
            state: {
              modal: true,
            },
          }),
        });
      } else {
        showWebsiteLoginForm();

        history.push(RoutesRedirectionFactory.getHomeRouteConfig());
      }
    }
  }, [history, isGREnabled]);

  if (!isConnected && !isConnecting) {
    return <NotFoundView label={__('You must be logged in to see this page')} imgPath={NotConnected1} />;
  }

  if (didReceivedUserData) {
    return (
      <Switch>
        <Route path={RoutePatterns.GR_ENROLLMENT} exact>
          <GREnrollmentContainer />
        </Route>
        <Route>
          <GRMainRouterSwitch />
        </Route>
      </Switch>
    );
  }

  return <StyledWinaLoader />;
};

const Wrapper = styled.div`
  font-family: 'BettingTroika';
  color: white;
`;

type GRRouterSwitchProps = {
  className?: string;
};

const GRRouterSwitch = ({ className = '' }: GRRouterSwitchProps) => {
  const { history } = useRouter();
  const showNotificationModal = useSelector((state) => !!state.gr.misc?.tmpNotifications?.length);

  const onCloseModal = useCallback(() => {
    history.replace(RoutesRedirectionFactory.getHomeRouteConfig());
  }, [history]);

  return (
    <Wrapper className={className}>
      <Switch>
        <Route path={RoutePatterns.GR}>
          {!Target.__MOBILE__ ? (
            <Modal
              backgroundColor={'#000000'}
              contentSpacing={ModalContentSpacing.NONE}
              hasOverlay
              closeOnOutsideClick
              closeOnEsc
              onClose={onCloseModal}
              withBorder
              hasCloseButton={!showNotificationModal}
              disableScrollView
            >
              <GRSubRouterSwitch />
            </Modal>
          ) : (
            <GRSubRouterSwitch />
          )}
        </Route>
      </Switch>
    </Wrapper>
  );
};

export default GRRouterSwitch;
